import React, { Component } from 'react';
import { Context } from '../../i18n';
import styled from 'styled-components';
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export default class Error extends Component {
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  render() {
    return (
      <Wrapper>
        <span>{this.context.net_error}</span>
      </Wrapper>
    );
  }
}
